import { SEND_MESSAGE_RECEIVE, SEND_MESSAGE_GROUPS_RECEIVE } from '../actions/communication';

let queryClient = null;

export const setQueryClient = (client) => {
  queryClient = client;
};

export const communicationQueryMiddleware = () => next => action => {
  const result = next(action);

  if (action.type === SEND_MESSAGE_RECEIVE || action.type === SEND_MESSAGE_GROUPS_RECEIVE) {
    if (queryClient) {
      queryClient.invalidateQueries({ queryKey: ['conversation'] });
    }
  }

  return result;
};
